import NotesView from "./NotesView";

export default NotesView;